module.exports = __webpack_public_path__ + "static/media/6880.be8fa60d.jpg";